<template>
  <div style="padding-top: 60px">
    <span v-if="isLoadding" style="height: 100px">
      <v-container
        fill-height
        fluid
        :style="
          display === 'Desktop'
            ? 'height: ' + (heightDisplay - 325) + 'px;'
            : 'height: ' + (heightDisplay - 150) + 'px;'
        "
      >
        <v-row align="center" justify="center">
          <v-col
            lg="12"
            sm="12"
            md="12"
            cols="12"
            xl="12"
            xs="12"
            class="text-center"
            ><h1 style="font-size: 48px">
              <span style="color: #3f44a3">Kan</span>
              <span style="color: #4a98b2">Pramool</span>
            </h1>
          </v-col>
          <v-col
            class="text-center"
            sm="10"
            md="6"
            cols="8"
            xl="3"
            xs="10"
            lg="3"
            ><v-progress-linear
              color="#F8F364"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear
          ></v-col>
        </v-row>
      </v-container>
    </span>
    <v-form v-model="valid">
      <v-dialog v-model="dialog" persistent max-width="400">
        <v-card>
          <v-card-title style="font-family: 'Kanit', sans-serif"
            >กรุณากรอกเลขโครงการ</v-card-title
          >
          <v-col cols="12" sm="12" md="12">
            <v-text-field
              placeholder="เลขที่โครงการ"
              type="text"
              @change="checkprojectCode()"
              v-model.trim="H_project_code"
              :rules="rules.project_code"
              outlined
              hide-details="auto"
              dense
            ></v-text-field>
          </v-col>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green" @click="checkTor()" style="color: #fff">
              <v-icon left light style="color: #fff"
                >mdi-content-save-outline</v-icon
              >
              เพิ่มข้อมูล
            </v-btn>
            <v-btn color="red" @click="cancelScreenedit()" style="color: #fff">
              <v-icon left light style="color: #fff">mdi-close-octagon</v-icon>
              ปิดหน้าจอ
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-container>
        <v-dialog v-model="dialog1" persistent max-width="1200" class="theme">
          <v-card>
            <v-img src="../assets/moph.gif" height="20%" dark> </v-img>
          </v-card>
        </v-dialog>
        <v-card class="mx-auto" max-width="1200px">
          <v-img src="../assets/3156482.jpg" height="200px"> </v-img>

          <v-row class="Format2">
            <v-col cols="12" sm="3" md="3" class="Format">
              <b>เลขโครงการ</b>
              <v-text-field
                disabled
                dense
                placeholder="เลขโครงการ"
                type="text"
                v-model="form.project_code"
                :rules="rules.project_code"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="5" md="5" class="Format">
              <b>ชื่อย่อโครงการ</b>
              <v-text-field
                placeholder="ชื่อย่อโครงการ"
                type="text"
                hide-details="auto"
                dense
                v-model="form.short_project_name"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="Format">
              <b>ชื่อหน่วยงานรับผิดชอบ</b>
              <v-text-field
                placeholder="ชื่อหน่วยงาน"
                type="text"
                hide-details="auto"
                dense
                v-model="form.institution"
                :rules="rules.institution"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="Format2">
            <v-col cols="12" sm="12" md="12" class="Format">
              <b>ชื่อโครงการ(เรื่อง)</b>
              <v-textarea
                outlined
                name="input-4-4"
                placeholder="ชื่อโครงการ(เรื่อง)"
                v-model="form.project_name"
                :rules="rules.project_name"
                dense
                rows="3"
                row-height="25"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-row class="Format2">
            <v-col cols="12" sm="4" md="4" class="Format">
              <b>จังหวัด</b>
              <v-autocomplete
                v-model="form.province"
                :rules="rules.province"
                :items="provinces"
                item-text="name_th"
                item-value="id"
                @input="getamphures()"
                outlined
                dense
                placeholder="จังหวัด"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="Format">
              <b>อำเภอ</b>
              <v-autocomplete
                v-model="form.amphures"
                @input="getdistricts()"
                :rules="rules.amphures"
                :items="amphuress"
                item-text="name_th"
                item-value="id"
                outlined
                dense
                placeholder="อำเภอ"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="3" md="3" class="Format">
              <b>ตำบล</b>
              <v-autocomplete
                v-model="form.districts"
                :rules="rules.districts"
                :items="districtss"
                item-text="name_th"
                item-value="id"
                outlined
                dense
                placeholder="ตำบล"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="Format2">
            <v-col
              cols="12"
              sm="2"
              md="2"
              style="padding-left: 0px"
              class="Format"
            >
              <v-card-text class="Format">
                <b> วันที่เริ่มเสนอราคา</b>
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                </v-menu>
                <v-dialog
                  ref="dialog"
                  v-model="modal1"
                  persistent
                  width="320px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      readonly
                      placeholder="คลิกเพื่อเลือก"
                      v-model="form.induce_date_start"
                      hide-details="auto"
                      v-bind="attrs"
                      v-on="on"
                      :rules="rules.induce_date_start"
                      outlined
                      dense
                      target="#dropdown-example-2"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.induce_date_start"
                    scrollable
                    locale="th-TH"
                    color="green lighten-1"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="success"
                      @click="$refs.dialog.save(day1), (modal1 = false)"
                    >
                      ตกลง
                    </v-btn>
                    <v-btn text color="red" @click="modal1 = false"
                      >ยกเลิก</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-card-text>
            </v-col>
            <v-col
              cols="12"
              sm="2"
              md="2"
              style="padding-left: 0px"
              class="Format"
            >
              <v-card-text class="Format">
                <b> วันที่ยื่นเสนอราคา</b>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                </v-menu>
                <v-dialog ref="dialog" v-model="modal" persistent width="320px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      readonly
                      placeholder="คลิกเพื่อเลือก"
                      v-model="form.submission_date"
                      hide-details="auto"
                      v-bind="attrs"
                      v-on="on"
                      :rules="rules.submission_date"
                      outlined
                      dense
                      target="#dropdown-example-2"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.submission_date"
                    scrollable
                    locale="th-TH"
                    color="green lighten-1"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="success"
                      @click="$refs.dialog.save(day), (modal = false)"
                    >
                      ตกลง
                    </v-btn>
                    <v-btn text color="red" @click="modal = false"
                      >ยกเลิก</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-card-text>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="Format">
              <b> latitude</b>
              <v-text-field
                placeholder="ตำเเหน่งหน้างานlatitude"
                type="text"
                hide-details="auto"
                dense
                v-model="form.latitude"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="Format">
              <b> longitude</b>
              <v-text-field
                placeholder="ตำเเหน่งหน้างานlongitude"
                v-model="form.longitude"
                hide-details="auto"
                outlined
                dense
                target="#dropdown-example-2"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="Format2">
            <v-col cols="12" sm="4" md="4" class="Format">
              <b>ประเภทการจัดหา</b>
              <v-autocomplete
                v-model="form.genus_typ"
                :rules="rules.genus_typ"
                :items="genusTyp"
                :readonly="checkDis"
                item-text="genus_typ_name"
                item-value="genus_typ_id"
                hide-details="auto"
                outlined
                dense
                placeholder="ประเภทการจัดหา"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="Format">
              <b>ประเภทงาน</b>
              <v-autocomplete
                v-model="form.type_of_work"
                :items="typeOfWork"
                :readonly="checkDis"
                item-text="job_type_name"
                item-value="job_type_id"
                hide-details="auto"
                outlined
                dense
                chips
                small-chips
                label="ประเภทงาน"
                multiple
                :rules="rules.type_of_work"
              >
                <template v-slot:selection="data">
                  <v-chip close small class="chip--select-multi">
                    {{ data.item.job_type_name }}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <template>
                    <v-list-item-content
                      v-text="data.item.job_type_name"
                    ></v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="Format">
              <b>งบประมาณโครงการ</b>
              <v-text-field
                placeholder="งบประมาณโครงการ"
                type="text"
                @change="checkexpenditure()"
                dense
                :readonly="checkDis"
                v-model="form.expenditure"
                :rules="rules.expenditure"
                outlined
                hide-details="auto"
              >
                <span slot="append">บาท</span></v-text-field
              >
            </v-col>
          </v-row>
          <v-row class="Format2">
            <v-col cols="12" sm="4" md="4" class="Format">
              <b> ราคากลาง</b>
              <v-text-field
                class="my-2"
                placeholder="ราคากลาง"
                v-model="form.middle_price"
                hide-details="auto"
                :rules="rules.middle_price"
                outlined
                dense
                @change="checkmiddlePrice()"
                target="#dropdown-example-2"
                ><span slot="append">บาท</span></v-text-field
              >
            </v-col>
            <v-col cols="12" sm="4" md="4" class="Format">
              <b> มูลค่าผลงานประเภทเดียวกัน</b>
              <v-text-field
                class="my-2"
                placeholder="มูลค่าผลงานประเภทเดียวกัน"
                v-model="form.same_price"
                hide-details="auto"
                :rules="rules.same_price"
                outlined
                dense
                @input="changeSame()"
                target="#dropdown-example-2"
                ><span slot="append">บาท</span></v-text-field
              >
            </v-col>
            <v-col cols="12" sm="4" md="4" class="Format">
              <b> ราคาซอง</b>
              <v-text-field
                class="my-2"
                dense
                @input="changeSecret()"
                placeholder="ราคาซอง"
                v-model="form.secret_price"
                hide-details="auto"
                :rules="rules.secret_price"
                outlined
                target="#dropdown-example-2"
                ><span slot="append">บาท</span></v-text-field
              >
            </v-col>
          </v-row>
          <v-row class="Format2">
            <v-col cols="12" sm="4" md="4" class="Format">
              <b> คุณสมบัติพิเศษ</b>
              <v-text-field
                dense
                placeholder="คุณสมบัติพิเศษ"
                v-model="form.special_features"
                hide-details="auto"
                :rules="rules.special_features"
                outlined
                target="#dropdown-example-2"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="Format">
              <b> เบอร์โทรหน่วยงาน</b>
              <v-text-field
                placeholder="เบอร์โทรหน่วยงาน"
                dense
                @input="changeTel()"
                type="text"
                v-model="form.institution_tall"
                :rules="rules.institution_tall"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="Format">
              <b> เเนบไฟล์เอกสาร</b>
              <v-file-input
                outlined
                dense
                accept=".pdf"
                prepend-icon=""
                placeholder="คลิกเพื่อเลือกไฟล์"
                @change="fileToBase64()"
                v-model="input_file"
                :rules="rules.input_file"
              ></v-file-input>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div class="text-center">
                <v-btn
                  style="width: 422px"
                  rounded
                  color="success"
                  :disabled="!valid"
                  @click="checkAdddata"
                  >บันทึกข้อมูลTORเข้าสู่ระบบ</v-btn
                >
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
    </v-form>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      day: "",
      modal: false,
      menu: false,
      day1: "",
      modal1: false,
      menu1: false,
      display: false,
      heightDisplay: null,
      show: false,
      isLoadding: true,
      isdata: false,
      checkcode: false,
      dialog1: false,
      valid: false,
      input_file: null,
      checkDis: true,
      projectStatus: [],
      genusTyp: [],
      typeOfWork: [],
      announcementType: [],
      provinces: [],
      dialog: false,
      check: null,
      H_project_code: null,
      call1: null,
      amphuress: [],
      districtss: [],
      form: {
        point_admin: null,
        point_staff: null,
        announcement_type: "new",
        short_project_name: "",
        type: "invite",
        institution: "", //ชื่อหน่วยงานรับผิดชอบ
        project_code: null, //รหัสโครงการ
        project_name: "", //ชื่อโครงการ
        tor_date_start: null, //วันที่เริ่มประกาศ
        tor_date_end: null, //วันที่สิ้นสุดประกาศ
        tor_date_project: null, //วันที่ประกาศ-วันที่สิ้นสุดรับฟังคำวิจารณ์
        expenditure: "", //งบประมาณโครงการ
        province: null, //จังหวัด
        amphures: null,
        districts: null,
        tor_status_id: 1,
        genus_typ: null, //ประเภทการจัดหา
        type_of_work: null, //ประเภทงาน
        induce_date_start: "", //วันที่เริ่มเชิญชวน
        middle_price: "", //ราคากลาง
        institution_tall: "", //เบอร์หน่วยงาน
        secret_price: "", //ราคาซอง
        submission_date: "", //วันที่ยื่นเสนอราคา
        same_price: "", //มูลค่าผลงานประเภทเดียวกัน
        special_features: "", //คุณสมบัติพิเศษ
        created_by: localStorage.getItem("username"), //เพิ่มโดย
        add_induce_status: 1,
        add_tor_status: 0,
        file_base64: null,
        latitude: null,
        longitude: null,
      },
      rules: {
        short_project_name: [
          (v) => (!!v && v.length <= 100) || "กรุณากรอกชื่อโครงการให้ถูกต้อง",
        ],
        input_file: [(v) => !!v || "กรุณาเลือกไฟล์"],
        expenditure: [
          (v) =>
            (!!v &&
              parseFloat(v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) >
                0) ||
            "กรุณากรอกราคางบประมาณให้ถูกต้อง",
        ],
        project_name: [
          (v) => (!!v && v.length <= 500) || "กรุณากรอกชื่อโครงการให้ถูกต้อง",
        ],
        project_code: [
          (v) => (!!v && v.length == 11) || "กรุณากรอกรหัสโครงการให้ถูกต้อง",
        ],
        institution: [
          (v) =>
            (!!v && v.length <= 100) ||
            "กรุณากรอกชื่อหน่วยงานรับผิดชอบให้ถูกต้อง",
        ],
        induce_date_start: [(v) => !!v || "กรุณากรอกวันที่เชิญชวนให้ถูกต้อง"],
        institution_tall: [(v) => !!v || "กรุณากรอกเบอร์โทรให้ถูกต้อง"],
        province: [(v) => !!v || "กรุณากรอกจังหวัดให้ถูกต้อง"],
        amphures: [(v) => !!v || "กรุณากรอกอำเภอให้ถูกต้อง"],
        districts: [(v) => !!v || "กรุณากรอกตำบลให้ถูกต้อง"],
        genus_typ: [(v) => !!v || "กรุณาเลือกประเภทการจัดหาให้ถูกต้อง"],
        type_of_work: [(v) => !!v || "กรุณาเลือกประเภทงานให้ถูกต้อง"],
        middle_price: [
          (v) =>
            (!!v &&
              parseFloat(v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) >
                0) ||
            "กรุณากรอกราคากลางให้ถูกต้อง",
        ],
        submission_date: [
          (v) => !!v || "กรุณากรอกวันที่ยื่นเสนอราคาให้ถูกต้อง",
        ],
        same_price: [
          (v) =>
            (!!v &&
              parseFloat(v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) >=
                0) ||
            "กรุณากรอกมูลค่าผลงานประเภทเดียวกันให้ถูกต้อง",
        ],
        special_features: [(v) => !!v || "กรุณากรอกคุณสมบัติพิเศษให้ถูกต้อง"],
        secret_price: [
          (v) =>
            (!!v &&
              parseFloat(v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) >=
                0) ||
            "กรุณากรอกราคาซองให้ถูกต้อง",
        ],
      },
    };
  },

  mounted() {
    this.checkHightDisplay();
    this.isLoadding = true;
    axios.get(this.api + "/get/ebiiding_jobtype").then((res) => {
      this.typeOfWork = [];
      this.typeOfWork = res.data.response;
      axios.get(this.api + "/get/tor_genus_typ").then((res) => {
        this.genusTyp = [];
        this.genusTyp = res.data.response;
      });
      axios.get(this.api + "/get/provinces").then((res) => {
        this.provinces = [];
        this.provinces = res.data.response;
      });
      this.isLoadding = false;
      this.dialog = true;
    });
  },
  methods: {
    checkHightDisplay() {
      this.heightDisplay = screen.height;
    },

    getamphures() {
      if (this.form.province != null) {
        this.isLoadding = true;
        axios
          .post(this.api + "/get/amphures", { province: this.form.province })
          .then((res) => {
            this.isLoadding = false;
            this.amphuress = res.data.response;
          });
      } else {
        alert("กรุณาเลือกจังหวัด");
      }
    },
    getdistricts() {
      if (this.form.amphures != null) {
        this.isLoadding = true;
        axios
          .post(this.api + "/get/districts", { amphure: this.form.amphures })
          .then((res) => {
            this.isLoadding = false;
            this.districtss = res.data.response;
          });
      } else {
        alert("กรุณาเลือกอำเภอ");
      }
    },
    checkprojectCode() {
      if (this.H_project_code != null) {
        if (this.H_project_code.length == 11) {
          if (this.H_project_code >= 1) {
            this.checkcode = true;
          } else {
            alert("กรุณากรอกข้อมูลเฉพาะตัวเลขเท่านั้น");
            location.reload();
          }
        } else {
          alert("กรุณากรอกข้อมูลเลขที่โครงการให้ครบ 11 หลัก");
          location.reload();
        }
      } else {
        alert("กรุณาเพิ่มข้อมูลโครงการ");
        location.reload();
      }
    },
    cancelScreenedit() {
      this.dialog1 = false;
      this.$router.push("/showdatainviteadmin");
    },
    refreshTable: function () {
      this.intervalid1 = setInterval(() => {
        this.dialog1 = false;
      }, 1000);
    },

    fileToBase64() {
      let reader = new FileReader();
      reader.readAsDataURL(this.input_file);
      reader.onload = () => {
        this.form.file_base64 = reader.result;
      };
    },
    checkTor() {
      if (this.H_project_code <= 0 && this.H_project_code >= 99999999999) {
        this.dialog = true;
      } else {
        this.isLoadding = true;
        this.dialog = false;
        if (this.H_project_code !== null && this.H_project_code !== "") {
          axios
            .post(this.api + "/projectcode", {
              project_code: this.H_project_code,
            })
            .then((res) => {
              this.isLoadding = false;
              if (res.data.response[0] !== undefined) {
                if (res.data.response[0].announcement_type === "invite") {
                  alert(
                    "เคยมีการเพิ่มเลขที่โครงการ " +
                      res.data.response[0].project_code +
                      " ภายในระบบข้อมูลเชิญชวนเเล้วโดย " +
                      res.data.response[0].created_by
                  );
                  location.reload();
                }
                let jop = [];
                for (
                  let index = 0;
                  index <
                  res.data.response[0].type_of_work_id
                    .replace(/'/g, "")
                    .split(",").length;
                  index++
                ) {
                  jop.push(
                    parseInt(
                      res.data.response[0].type_of_work_id
                        .replace(/'/g, "")
                        .split(",")[index]
                    )
                  );
                }

                this.checkDis = true;
                this.check = "old";
                this.form.short_project_name =
                  res.data.response[0].short_project_name;
                this.form.tor_id = res.data.response[0].id;
                this.form.institution = res.data.response[0].institution;
                this.form.project_code = res.data.response[0].project_code;
                this.form.tor_date_start = res.data.response[0].tor_date_start;
                this.form.districts = res.data.response[0].tambon;
                this.form.amphures = parseInt(res.data.response[0].amphoe);
                this.form.tor_date_end = res.data.response[0].tor_date_end;
                this.form.project_name = res.data.response[0].project_name;
                this.form.expenditure = res.data.response[0].expenditure;
                this.form.middle_price = res.data.response[0].middle_price;
                this.form.province = parseInt(res.data.response[0].province);
                this.form.genus_typ = parseInt(
                  res.data.response[0].genus_typ_id
                );
                if (this.form.province !== null) {
                  this.getamphures();
                }
                if (this.form.amphures !== null) {
                  this.getdistricts();
                }

                this.form.type_of_work = res.data.response[0].type_of_work_id
                  .replace(/'/g, "")
                  .split(",");
              } else {
                this.check = "new";
                this.checkDis = false;
                this.form.project_code = this.H_project_code;
              }
            });
        } else {
          alert("เกิดความผิดพลาดในการเรียกข้อมูล");
          this.dialog = true;
        }
      }
    },

    changeSecret() {
      this.form.secret_price = this.form.secret_price
        .replace(/๑/g, "1")
        .replace(/๒/g, "2")
        .replace(/๓/g, "3")
        .replace(/๔/g, "4")
        .replace(/๕/g, "5")
        .replace(/๖/g, "6")
        .replace(/๗/g, "7")
        .replace(/๘/g, "8")
        .replace(/๙/g, "9")
        .replace(/๐/g, "0")
        .trim();
    },
    changeTel() {
      this.form.institution_tall = this.form.institution_tall
        .replace(/๑/g, "1")
        .replace(/๒/g, "2")
        .replace(/๓/g, "3")
        .replace(/๔/g, "4")
        .replace(/๕/g, "5")
        .replace(/๖/g, "6")
        .replace(/๗/g, "7")
        .replace(/๘/g, "8")
        .replace(/๙/g, "9")
        .replace(/๐/g, "0")
        .replace(/-/g, "")
        .trim();
    },
    changeSame() {
      this.form.same_price = this.form.same_price
        .replace(/๑/g, "1")
        .replace(/๒/g, "2")
        .replace(/๓/g, "3")
        .replace(/๔/g, "4")
        .replace(/๕/g, "5")
        .replace(/๖/g, "6")
        .replace(/๗/g, "7")
        .replace(/๘/g, "8")
        .replace(/๙/g, "9")
        .replace(/๐/g, "0")
        .trim();
    },
    changeSame2() {
      this.form.middle_price = this.form.middle_price
        .replace(/๑/g, "1")
        .replace(/๒/g, "2")
        .replace(/๓/g, "3")
        .replace(/๔/g, "4")
        .replace(/๕/g, "5")
        .replace(/๖/g, "6")
        .replace(/๗/g, "7")
        .replace(/๘/g, "8")
        .replace(/๙/g, "9")
        .replace(/๐/g, "0")
        .trim();
    },
    newAddSubMit() {
      this.isLoadding = true;
      this.form.point_admin = -1;
      this.form.point_staff = -1;
      this.form.project_name = this.form.project_name
        .split("(เลขที่โครงการ")[0]
        .trim();
      axios.post(this.api + "/post/adddata_invite", this.form).then((res) => {
        this.isLoadding = true;
        this.form.tor_id = res.data.response;
        if (res.data.status) {
          this.$router.go();
        } else {
          alert("กรอกข้อมูลผิดพลาด");
        }
      });
    },
    updatetor() {
      this.isLoadding = true;
      this.form.point_admin = 0;
      this.form.point_staff = 0;
      this.form.project_name = this.form.project_name
        .split("(เลขที่โครงการ")[0]
        .trim();
      this.form.announcement_type = "invite";
      axios
        .post(this.api + "/update/data_invite_new", this.form)
        .then((res) => {
          this.isLoadding = false;
          if (res.data.status) {
            this.$router.go();
          } else {
            alert("กรอกข้อมูลผิดพลาด");
          }
        });
    },
    checkAdddata() {
      this.dialog = false;
      this.isdata = false;
      this.isLoadding = true;
      if (this.check === "new") {
        this.newAddSubMit();
        this.refreshTable();
      } else {
        this.updatetor();
        this.refreshTable();
      }
    },
    checkexpenditure() {
      if (this.form.expenditure <= 10) {
        alert("งบประมาณโครงการน้อยกว่ากำหนด");
      }
    },
    checkmiddlePrice() {
      this.changeSame2();
      if (this.form.middle_price <= 10) {
        alert("ราคากลางน้อยกว่ากำหนด");
      }
      if (this.form.middle_price === undefined) {
        alert("ไม่มีข้อมูล");
      }
      if (this.form.expenditure !== null) {
        this.call1 =
          ((this.form.expenditure - this.form.middle_price) /
            this.form.expenditure) *
          100;
        if (this.call1 >= 40) {
          alert("ราคากลางเเละงบประมาณมีส่วนต่างเกิน 40%");
        }
      }
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Kanit&display=swap");
.home-page {
  padding-top: 0px;
  padding-bottom: 0px;
}
.Format2 {
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
}
.Format {
  padding-top: 0px;
  padding-bottom: 0px;
}
.inputOrderIn {
  font-size: 30px;
  font-weight: bold;
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>
